import { SelectionAny } from './internal';
import { SelectionWithNoteMixin } from './mixin';
export class SelectionChildFamilyLink extends SelectionWithNoteMixin(SelectionAny) {
    getFamilyRecord() {
        return this.root().getFamilyRecord(this.valueNonNull());
    }
    getPedigreeLinkageType() {
        return this.get("PEDI" /* Tag.Pedigree */);
    }
}
//# sourceMappingURL=SelectionChildFamilyLink.js.map